import { useState, useEffect } from 'react';
import moment from 'moment';
import { getAllDataWithFlag } from '../services/CommonService';
import './pages.css';
import EventCard from '../components/User/EventNews/EventCard';
import { imgURL } from '../components/Config';
import Swal from 'sweetalert2';

const EventPage = ({ projectId }) => {
  const [eventdata, setEventdata] = useState([]);
  const [lookupData, setLookupData] = useState([]);
  const [upcomingEvent, setUpcomingEvent] = useState([]);

  useEffect(() => {
    const lookup = JSON.parse(localStorage?.getItem('lookup'));
    if (lookup) setLookupData(lookup);
    const fetchData = async () => {
      try {
        const response = await getAllDataWithFlag(6);
        let eventData = response?.data?.event?.filter((m) => (m?.is_deleted != 1));
        eventData?.sort((a, b) => (new Date(b?.event_date) - new Date(a?.event_date)));
        if (projectId) eventData = eventData.filter((m) => m.project_id == projectId);
        setEventdata(eventData?.filter((res) => (moment(res?.event_end_date).isBefore(moment()))) || []);
        const upcoming = eventData?.filter((res) => (moment(res?.event_end_date).isAfter(moment())));
        setUpcomingEvent(upcoming || []);

      } catch (err) {
        Swal.fire({
          title: "Error",
          text: err?.response?.data?.message || err?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    };
    fetchData();
  }, []);

  const banners = JSON.parse(localStorage.getItem('banners'));
  const bannerItem = (banners || []).find((r) => r.banner_type == 7);
  if (!eventdata?.length && !upcomingEvent?.length) return null;
  return (
    <div style={{ backgroundColor: '#f5f6fa' }}>
      {!projectId && <div className="position-relative">
        {bannerItem?.image_path ? (
          <img
            src={`${imgURL}${bannerItem?.image_path}` || 'assets/images/bannerDefault.jpg'}
            alt="Groundwater"
            className="img-fluid w-100"
            style={{ minHeight: '350px', maxHeight: '350px', objectFit: 'cover' }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.style.display = 'none';
            }}
          />
        ) : (
          <div
            className="w-100 h-100"
            style={{
              minHeight: '350px',
              maxHeight: '350px',
              backgroundColor: '#e9ecef',
            }}
          />
        )}
        <div className="position-absolute top-50 start-50 translate-middle text-center p-4" style={{ width: "80%", marginTop: '100px' }}>
          <div className="container position-relative bg-light bg-opacity-75 p-4 shadow rounded" style={{ marginTop: '-65px' }}>
            <h1 className="fw-bold" style={{ color: '#0a3d62' }}>Our Upcoming Events</h1>
            <div className="alert alert-warning text-center rounded-pill fs-6 fw-bold-400 mt-3" >
              Upcoming trainings and dialogues designed to strengthen skills, share insights, and drive collective action in groundwater governance.
            </div>
          </div>
        </div>
      </div>}
      <div className="container py-5 mb-4" >
        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
          {upcomingEvent.map(event => (
            <EventCard key={event.id} event={event} register={true} lookupData={lookupData} />
          ))}
        </div>
        {(eventdata?.length > 0) && <h1 className='my-4'>{!projectId && 'Past'} Events</h1>}
        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
          {eventdata.map(event => (
            <EventCard key={event.id} event={event} register={false} lookupData={lookupData} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default EventPage;
